import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.83 3.17a.75.75 0 0 1 0 1.06l-12.6 12.6a.75.75 0 0 1-1.06-1.06l12.6-12.6a.75.75 0 0 1 1.06 0m-12.9.759a.75.75 0 0 1 .53-.22h8.04a.75.75 0 0 1 0 1.5H5.21v.51l2.722 3.48a.75.75 0 1 1-1.182.925L3.868 6.439a.75.75 0 0 1-.159-.462V4.46a.75.75 0 0 1 .22-.53m7.7 6.621a.75.75 0 0 1 .75.75v3.254a.75.75 0 0 1-.532.718l-3.26.987a.75.75 0 0 1-.967-.718V14.5a.75.75 0 0 1 1.5 0v.03l1.76-.532V11.3a.75.75 0 0 1 .75-.75",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=FilterOffIcon20.js.map